<template>
    <div className="lv-column-group">
        <slot></slot>
    </div>
</template>

<script>
    import {MountedMixin} from "../mixins";
    import {ColumnGroupProps} from "../table-expansion/mixins";
    import {TableColumnGroup} from "../table-expansion/mixins";

    export default {
        name: "lv-column-group",
        mixins: [MountedMixin],
        props: ColumnGroupProps,
        methods: {
            col() {
                const col = new TableColumnGroup(this)
                const children = this.$children.reduce((ret, item) => {
                    if (item.$options._componentTag === 'link-rendering-render-func') {
                        item.$children.forEach(c => ret.push(c.col()))
                    } else {
                        ret.push(item.col())
                    }
                    return ret
                }, [])
                this.$set(col, 'children', children)
                col.group = true
                return col
            },
        },
    }
</script>
